import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { GET_MY_ADS, GET_MY_AD_STATS } from '../graphql/queries';
import Layout from '../components/Layout';
import AdCard from '../components/Ads/AdCard';
import { Link } from 'react-router-dom';
import { Tabs, Tab, Card, Button, Row, Col } from 'react-bootstrap';

const Dashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const { data: statsData } = useQuery(GET_MY_AD_STATS);
  const { data: adsData, loading: adsLoading } = useQuery(GET_MY_ADS);

  const stats = statsData?.myAdStats || {};
  const ads = adsData?.myAds || [];

  const filteredAds = activeTab === 'active'
    ? ads.filter((ad: any) => ad.status === 'active')
    : activeTab === 'ads'
    ? ads
    : ads.slice(0, 4);

  return (
    <Layout showSidebar={false}>
      <div className="pw-page">
      {/* Header */}
      <div className="mb-4">
        <h1 className="pw-title">Dashboard</h1>
        <p className="pw-muted">Manage your ads and account</p>
      </div>

      {/* Stats Cards */}
      <Row className="mb-4">
        <Col md={3} className="mb-3 mb-md-0">
          <Card className="h-100 border-0 pw-card">
            <Card.Body>
              <div className="display-6 fw-bold text-primary">{stats.total_ads || 0}</div>
              <div className="text-muted">Total Ads</div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} className="mb-3 mb-md-0">
          <Card className="h-100 border-0 pw-card">
            <Card.Body>
              <div className="display-6 fw-bold text-success">{stats.active_ads || 0}</div>
              <div className="text-muted">Active Ads</div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} className="mb-3 mb-md-0">
          <Card className="h-100 border-0 pw-card">
            <Card.Body>
              <div className="display-6 fw-bold text-info">{stats.total_views || 0}</div>
              <div className="text-muted">Total Views</div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="h-100 border-0 pw-card">
            <Card.Body>
              <div className="display-6 fw-bold" style={{ color: '#6f42c1' }}>{stats.total_contacts || 0}</div>
              <div className="text-muted">Contacts</div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Tabs */}
      <Card className="border-0 pw-card">
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k as string)}
          className="mb-3 px-3 pt-3"
        >
          <Tab eventKey="overview" title="Overview">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h2>Recent Ads</h2>
                <Link to="/post-ad">
                  <Button variant="primary">
                    <i className="bi bi-plus-circle me-2"></i>
                    Post New Ad
                  </Button>
                </Link>
              </div>
              {adsLoading ? (
                <div className="text-center py-5">Loading...</div>
              ) : filteredAds.length === 0 ? (
                <div className="text-center py-5">
                  <p className="text-muted mb-4">You haven't posted any ads yet.</p>
                  <Link to="/post-ad">
                    <Button variant="primary">
                      <i className="bi bi-plus-circle me-2"></i>
                      Post Your First Ad
                    </Button>
                  </Link>
                </div>
              ) : (
                <Row>
                  {filteredAds.map((ad: any) => (
                    <Col key={ad.id} xs={12} sm={6} lg={3} className="mb-4">
                      <AdCard ad={ad} />
                    </Col>
                  ))}
                </Row>
              )}
            </Card.Body>
          </Tab>

          <Tab eventKey="ads" title="My Ads">
            <Card.Body>
              <h2 className="mb-4">All Ads</h2>
              {adsLoading ? (
                <div className="text-center py-5">Loading...</div>
              ) : filteredAds.length === 0 ? (
                <div className="text-center py-5 text-muted">
                  No ads found in this category.
                </div>
              ) : (
                <Row>
                  {filteredAds.map((ad: any) => (
                    <Col key={ad.id} xs={12} sm={6} lg={3} className="mb-4">
                      <AdCard ad={ad} />
                    </Col>
                  ))}
                </Row>
              )}
            </Card.Body>
          </Tab>

          <Tab eventKey="active" title="Active">
            <Card.Body>
              <h2 className="mb-4">Active Ads</h2>
              {adsLoading ? (
                <div className="text-center py-5">Loading...</div>
              ) : filteredAds.length === 0 ? (
                <div className="text-center py-5 text-muted">
                  No ads found in this category.
                </div>
              ) : (
                <Row>
                  {filteredAds.map((ad: any) => (
                    <Col key={ad.id} xs={12} sm={6} lg={3} className="mb-4">
                      <AdCard ad={ad} />
                    </Col>
                  ))}
                </Row>
              )}
            </Card.Body>
          </Tab>

          <Tab eventKey="favorites" title="Favorites">
            <Card.Body>
              <div className="text-center py-5">
                <i className="bi bi-heart" style={{ fontSize: '4rem', color: '#dee2e6' }}></i>
                <p className="text-muted mt-3">Your favorite ads will appear here.</p>
                <Link to="/">
                  <Button variant="primary" className="mt-3">
                    Browse Ads
                  </Button>
                </Link>
              </div>
            </Card.Body>
          </Tab>
        </Tabs>
      </Card>
      </div>
    </Layout>
  );
};

export default Dashboard;
